"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIrecCertificateControllerGetAllEvents = exports.getIrecCertificateControllerGetAllEventsQueryKey = exports.irecCertificateControllerGetAllEvents = exports.useIrecCertificateControllerTransfer = exports.irecCertificateControllerTransfer = exports.useIrecCertificateControllerGetAggregateCertifiedEnergyByDeviceId = exports.getIrecCertificateControllerGetAggregateCertifiedEnergyByDeviceIdQueryKey = exports.irecCertificateControllerGetAggregateCertifiedEnergyByDeviceId = exports.useIrecCertificateControllerIssue = exports.irecCertificateControllerIssue = exports.useIrecCertificateControllerGetAll = exports.getIrecCertificateControllerGetAllQueryKey = exports.irecCertificateControllerGetAll = exports.useIrecCertificateControllerGetByTxHash = exports.getIrecCertificateControllerGetByTxHashQueryKey = exports.irecCertificateControllerGetByTxHash = exports.useIrecCertificateControllerGet = exports.getIrecCertificateControllerGetQueryKey = exports.irecCertificateControllerGet = exports.useIrecCertificateControllerClaim = exports.irecCertificateControllerClaim = void 0;
/**
 * Generated by orval v6.5.1 🍺
 * Do not edit manually.
 * Exchange I-REC API
 * Swagger documentation for the Exchange I-REC API
 * OpenAPI spec version: 0.1
 */
const react_query_1 = require("react-query");
const response_type_1 = __importDefault(require("../response-type"));
const response_type_2 = __importDefault(require("../response-type"));
const response_type_3 = __importDefault(require("../response-type"));
const response_type_4 = __importDefault(require("../response-type"));
const response_type_5 = __importDefault(require("../response-type"));
const response_type_6 = __importDefault(require("../response-type"));
const response_type_7 = __importDefault(require("../response-type"));
const response_type_8 = __importDefault(require("../response-type"));
const irecCertificateControllerClaim = (id, claimCertificateDTO) => {
    return (0, response_type_1.default)({ url: `/api/irec/certificate/${id}/claim`, method: 'put',
        data: claimCertificateDTO
    });
};
exports.irecCertificateControllerClaim = irecCertificateControllerClaim;
const useIrecCertificateControllerClaim = (options) => {
    const { mutation: mutationOptions } = options || {};
    const mutationFn = (props) => {
        const { id, data } = props || {};
        return (0, exports.irecCertificateControllerClaim)(id, data);
    };
    return (0, react_query_1.useMutation)(mutationFn, mutationOptions);
};
exports.useIrecCertificateControllerClaim = useIrecCertificateControllerClaim;
const irecCertificateControllerGet = (id) => {
    return (0, response_type_2.default)({ url: `/api/irec/certificate/${id}`, method: 'get'
    });
};
exports.irecCertificateControllerGet = irecCertificateControllerGet;
const getIrecCertificateControllerGetQueryKey = (id) => [`/api/irec/certificate/${id}`];
exports.getIrecCertificateControllerGetQueryKey = getIrecCertificateControllerGetQueryKey;
const useIrecCertificateControllerGet = (id, options) => {
    var _a;
    const { query: queryOptions } = options || {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : (0, exports.getIrecCertificateControllerGetQueryKey)(id);
    const queryFn = () => (0, exports.irecCertificateControllerGet)(id);
    const query = (0, react_query_1.useQuery)(queryKey, queryFn, Object.assign({ enabled: !!(id) }, queryOptions));
    return Object.assign({ queryKey }, query);
};
exports.useIrecCertificateControllerGet = useIrecCertificateControllerGet;
const irecCertificateControllerGetByTxHash = (txHash) => {
    return (0, response_type_3.default)({ url: `/api/irec/certificate/by-transaction/${txHash}`, method: 'get'
    });
};
exports.irecCertificateControllerGetByTxHash = irecCertificateControllerGetByTxHash;
const getIrecCertificateControllerGetByTxHashQueryKey = (txHash) => [`/api/irec/certificate/by-transaction/${txHash}`];
exports.getIrecCertificateControllerGetByTxHashQueryKey = getIrecCertificateControllerGetByTxHashQueryKey;
const useIrecCertificateControllerGetByTxHash = (txHash, options) => {
    var _a;
    const { query: queryOptions } = options || {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : (0, exports.getIrecCertificateControllerGetByTxHashQueryKey)(txHash);
    const queryFn = () => (0, exports.irecCertificateControllerGetByTxHash)(txHash);
    const query = (0, react_query_1.useQuery)(queryKey, queryFn, Object.assign({ enabled: !!(txHash) }, queryOptions));
    return Object.assign({ queryKey }, query);
};
exports.useIrecCertificateControllerGetByTxHash = useIrecCertificateControllerGetByTxHash;
const irecCertificateControllerGetAll = (params) => {
    return (0, response_type_4.default)({ url: `/api/irec/certificate`, method: 'get',
        params,
    });
};
exports.irecCertificateControllerGetAll = irecCertificateControllerGetAll;
const getIrecCertificateControllerGetAllQueryKey = (params) => [`/api/irec/certificate`, ...(params ? [params] : [])];
exports.getIrecCertificateControllerGetAllQueryKey = getIrecCertificateControllerGetAllQueryKey;
const useIrecCertificateControllerGetAll = (params, options) => {
    var _a;
    const { query: queryOptions } = options || {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : (0, exports.getIrecCertificateControllerGetAllQueryKey)(params);
    const queryFn = () => (0, exports.irecCertificateControllerGetAll)(params);
    const query = (0, react_query_1.useQuery)(queryKey, queryFn, queryOptions);
    return Object.assign({ queryKey }, query);
};
exports.useIrecCertificateControllerGetAll = useIrecCertificateControllerGetAll;
const irecCertificateControllerIssue = (issueCertificateDTO) => {
    return (0, response_type_5.default)({ url: `/api/irec/certificate`, method: 'post',
        data: issueCertificateDTO
    });
};
exports.irecCertificateControllerIssue = irecCertificateControllerIssue;
const useIrecCertificateControllerIssue = (options) => {
    const { mutation: mutationOptions } = options || {};
    const mutationFn = (props) => {
        const { data } = props || {};
        return (0, exports.irecCertificateControllerIssue)(data);
    };
    return (0, react_query_1.useMutation)(mutationFn, mutationOptions);
};
exports.useIrecCertificateControllerIssue = useIrecCertificateControllerIssue;
const irecCertificateControllerGetAggregateCertifiedEnergyByDeviceId = (deviceId, params) => {
    return (0, response_type_6.default)({ url: `/api/irec/certificate/issuer/certified/${deviceId}`, method: 'get',
        params,
    });
};
exports.irecCertificateControllerGetAggregateCertifiedEnergyByDeviceId = irecCertificateControllerGetAggregateCertifiedEnergyByDeviceId;
const getIrecCertificateControllerGetAggregateCertifiedEnergyByDeviceIdQueryKey = (deviceId, params) => [`/api/irec/certificate/issuer/certified/${deviceId}`, ...(params ? [params] : [])];
exports.getIrecCertificateControllerGetAggregateCertifiedEnergyByDeviceIdQueryKey = getIrecCertificateControllerGetAggregateCertifiedEnergyByDeviceIdQueryKey;
const useIrecCertificateControllerGetAggregateCertifiedEnergyByDeviceId = (deviceId, params, options) => {
    var _a;
    const { query: queryOptions } = options || {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : (0, exports.getIrecCertificateControllerGetAggregateCertifiedEnergyByDeviceIdQueryKey)(deviceId, params);
    const queryFn = () => (0, exports.irecCertificateControllerGetAggregateCertifiedEnergyByDeviceId)(deviceId, params);
    const query = (0, react_query_1.useQuery)(queryKey, queryFn, Object.assign({ enabled: !!(deviceId) }, queryOptions));
    return Object.assign({ queryKey }, query);
};
exports.useIrecCertificateControllerGetAggregateCertifiedEnergyByDeviceId = useIrecCertificateControllerGetAggregateCertifiedEnergyByDeviceId;
const irecCertificateControllerTransfer = (id, transferCertificateDTO) => {
    return (0, response_type_7.default)({ url: `/api/irec/certificate/${id}/transfer`, method: 'put',
        data: transferCertificateDTO
    });
};
exports.irecCertificateControllerTransfer = irecCertificateControllerTransfer;
const useIrecCertificateControllerTransfer = (options) => {
    const { mutation: mutationOptions } = options || {};
    const mutationFn = (props) => {
        const { id, data } = props || {};
        return (0, exports.irecCertificateControllerTransfer)(id, data);
    };
    return (0, react_query_1.useMutation)(mutationFn, mutationOptions);
};
exports.useIrecCertificateControllerTransfer = useIrecCertificateControllerTransfer;
const irecCertificateControllerGetAllEvents = (id) => {
    return (0, response_type_8.default)({ url: `/api/irec/certificate/${id}/events`, method: 'get'
    });
};
exports.irecCertificateControllerGetAllEvents = irecCertificateControllerGetAllEvents;
const getIrecCertificateControllerGetAllEventsQueryKey = (id) => [`/api/irec/certificate/${id}/events`];
exports.getIrecCertificateControllerGetAllEventsQueryKey = getIrecCertificateControllerGetAllEventsQueryKey;
const useIrecCertificateControllerGetAllEvents = (id, options) => {
    var _a;
    const { query: queryOptions } = options || {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : (0, exports.getIrecCertificateControllerGetAllEventsQueryKey)(id);
    const queryFn = () => (0, exports.irecCertificateControllerGetAllEvents)(id);
    const query = (0, react_query_1.useQuery)(queryKey, queryFn, Object.assign({ enabled: !!(id) }, queryOptions));
    return Object.assign({ queryKey }, query);
};
exports.useIrecCertificateControllerGetAllEvents = useIrecCertificateControllerGetAllEvents;
//# sourceMappingURL=irec-certificates.js.map